import { PRODUCT_TYPE } from '@shootsta/common-domain-data';
import basePath from '../constants/proPath';
import elevatePath from '../constants/elevatePath';

export default function getBasePathByProductType(productType?: string) {
  if (
    productType === PRODUCT_TYPE.PITCHTEMPLATE ||
    productType === PRODUCT_TYPE.PITCH
  ) {
    return elevatePath;
  }

  return basePath;
}
